module.exports = __webpack_public_path__ + "static/media/DP.acb034fe.png";